import { atom } from "jotai";
import {
  createDerivedWritableAtom,
  filterNonNullable,
} from "../../../../../utils";
import { videoSDKAtom } from "../../../atoms";
import { LocalMediaStatus } from "../../../types";
import { remoteAudioDelegatorsAtom } from "../atoms";

// Audio Delegator
export const localAudioContextAtom = createDerivedWritableAtom(
  videoSDKAtom,
  "localAudioContext",
);

export const localAudioStatusAtom = createDerivedWritableAtom(
  localAudioContextAtom,
  "status",
);

export const isOwnAudioOffAtom = atom((get) => {
  const { delegator, status } = get(localAudioContextAtom);
  return !delegator || status !== LocalMediaStatus.READY;
});

export const currentMicrophoneIdAtom = atom(
  (get) => get(localAudioContextAtom).delegator?.deviceId,
);

export const allAudioTracksAtom = atom((get) => {
  const localAudioTrack = get(localAudioContextAtom);
  const remoteAudioTracks = get(remoteAudioDelegatorsAtom);

  return filterNonNullable([localAudioTrack.delegator, ...remoteAudioTracks]);
});

// Video Delegator
export const localVideoContextAtom = createDerivedWritableAtom(
  videoSDKAtom,
  "localVideoContext",
);

export const localVideoStatusAtom = createDerivedWritableAtom(
  localVideoContextAtom,
  "status",
);

export const isOwnVideoOffAtom = atom((get) => {
  const { delegator, status } = get(localVideoContextAtom);
  return !delegator || status !== LocalMediaStatus.READY;
});

export const currentCameraIdAtom = atom(
  (get) => get(localVideoContextAtom).delegator?.deviceId,
);
